
export enum DiscountBandTypeEnum {
  Discrete,
  Compound
}

export class DiscountBandType {
    private mode: string;
    private description: string; 
    private example: string; 
    private exampleExplanation: string
    private enumValue : DiscountBandTypeEnum
  
    constructor(enumValue: DiscountBandTypeEnum, mode: string, description: string, example: string, exampleExplanation: string) {
      this.enumValue = enumValue;
      this.mode = mode;
      this.description = description;
      this.example = example; 
      this.exampleExplanation = exampleExplanation
    }

    toEnumValue() {
      return this.enumValue;
    }
   
    get Mode() {
        return this.mode; 
      }

    get Description() {
      return this.description;
    }

    get Example() {
      return this.example;
    }

    get ExampleExplanation() {
      return this.exampleExplanation; 
    }
  
    private static readonly discrete = new DiscountBandType(
        DiscountBandTypeEnum.Discrete,
        'Standard mode', 
        'A single discount amount will be applied to all units of the item', 
        'Discount 1-4 weeks: 10% off, 5+ weeks: 15% off', 
        'If we sell 5 weeks for a value of $1000, then 15% discount will be applied to all units of the item, giving a $150 discount'); 
    
      private static readonly compound = new DiscountBandType(
        DiscountBandTypeEnum.Compound,
        'Compound mode', 
        'Multiple discount amounts will be applied to the item', 
        'Discount 1-4 weeks: 10% off, 5+ weeks: 15% off', 
        'If we sell 5 weeks for a value of $1000, then 10% discount will be applied to the first 4 weeks and 15% will be applied to 5th week of the item to give a discount of (4 x $20) + (1 x $30) = $110 total');
            
    static get Discrete() : DiscountBandType { return DiscountBandType.discrete };
    static get Compound() : DiscountBandType { return DiscountBandType.compound };

    static FromEnum(enumValue: DiscountBandTypeEnum) {
      switch (enumValue) {
        case DiscountBandTypeEnum.Compound:
          return this.Compound;
        case DiscountBandTypeEnum.Discrete:
          return this.Discrete;
        default: 
          throw new Error('Unknown discount band type enum: ' + enumValue)
      }
    }

    static get AllValues() : DiscountBandType[] {
      return [
        DiscountBandType.Discrete, 
        DiscountBandType.Compound
      ];
    }
  }